import * as go from 'gojs';

import { ExtendedDiagram } from 'src/containers/ProjectDiagram/templates/extensions/diagram';
import { ExtendedLayeredDigraphLayout } from 'src/containers/ProjectDiagram/templates/extensions/layouts/LayeredLayout/ExtendedLayeredDigraphLayout';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { rescaleDiagram } from 'src/containers/ProjectDiagram/utils/rescaleDiagram';

export const redrawLayout = (_model: Model, diagram: ExtendedDiagram) => {
  diagram.nodes.each((node) => {
    // eslint-disable-next-line no-param-reassign
    node.location = new go.Point(NaN, NaN);
  });

  if (diagram.layout instanceof ExtendedLayeredDigraphLayout) {
    diagram.layout.reset(true);
  }
  diagram.layoutDiagram(true);

  rescaleDiagram(diagram, true);
};
